import * as React from 'react';
const FragilitàCapillareIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}`}</style>
    </defs>
    <path
      d="M68.6 58.24s-.16 22.16 9.42 36.77c9.57 14.61 13.49 20.23 10.26 26.47-3.24 6.24-4.98 13.61 1.62 14.99 6.6 1.37 10.46-.37 16.43 6.37s12.82 5.74 19.29 4.62 7.47-6.87 3.24-9.12-6.9.28-12.2-8.12c-6.02-9.54-5.49-8.94-8.47-15.69-2.93-6.64-6.11-13.43-8.17-30.56-2.24-18.63-8.87-32.24-8.87-32.24"
      style={{
        fill: 'none',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '3.89px',
        stroke: primaryColor || '#282828',
      }}
    />
    <path
      d="M80.19 60.81s.16 16.22 8.59 29.55c8.1 12.82 11.53 25.77 9.61 32.77-1.76 6.42 5.81 8.17 10.39 10.52"
      className="prefix__cls-1"
    />
    <path
      d="M81.15 69.6s5.12 6.3 11.55 6.3M88.25 89.49s1.4 5.37 0 8.8"
      className="prefix__cls-1"
    />
  </svg>
);
export default FragilitàCapillareIcon;
